// extracted by mini-css-extract-plugin
module.exports = {"catalogTrackerSkuDetailsWrapper":"-catalog-tracker-sku-details-body-catalogTrackerSkuDetailsWrapper-1qJXec-"};